import { Suspense, useState } from 'react'
import {
    Await,
    defer,
    Link,
    useSearchParams,
    useNavigate,
    useLoaderData,
    json
} from 'react-router-dom'
import { vr } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/Home.module.scss'
import Tour from './components/Tour'
import { useEffect } from 'react'

export const loader = async () => {
    return defer({ vr: vr() })
}

export default function VirtualTour() {
    const pageName = 'تور مجازی'
    Title(pageName)

    const [loaderData, setLoaderData] = useState(useLoaderData())

    const [error, setError] = useState()
    const [data, setData] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [showPopup, setShowPopup] = useState(false)

    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()

    useEffect(() => {
        document.querySelector('header span').innerText = pageName
    }, [])

    return (
        <section className={styles.group}>
            <div className='__frame' data-width={`medium`}>
                <div className='grid grid--fit grid--gap-1' style={{ '--data-width': '300px' }}>
                    <Suspense fallback={<LoadingSpinner />}>
                        <Await
                            resolve={loaderData.vr}
                            errorElement={<p>⚠️</p>}>
                            {(data) => {
                                return <Tour data={data} />
                            }}
                        </Await>
                    </Suspense>
                </div>
                <button className='button' onClick={()=>navigate(`/tourism/ardabil/1`)} style={{marginTop:'1rem'}}>بازگشت</button>
            </div>
        </section>
    )
}